module.exports = __webpack_public_path__ + "img/car-mask-2.fee00989.png";